
// 全部保单接口
import request from '../request'
// 杏树林在线问诊权限获取
const getRightOfConsult = (data) => {
  return request.post('/api/wx/auth/getIsXsl', data)
}
// 杏树林在线问诊url获取
const getConsultUrl = (data, config) => {
  return request.post('/api/wx/auth/getInquiryUrl', data, config)
}
// 杏树林在线问诊url跳转
const goConsultUrl = (url, config) => {
  return request.post(url, undefined, config)
}
// 健康咨询
const inquiryOnline = function () {
  return request.post('/api/wx/auth/getUdeskClientUrl')
}
// 视频医生权限判断
const getVideoDoctorRight = function (data) {
  return request.post('/api/wx/auth/getIsVideoDoct', data)
}
// 视频医生
const getVideoDoctorUrl = function (data) {
  return request.post('/api/wx/auth/getVideoDoctorUrl', data)
}
// 对象数组
export default {
  getRightOfConsult,
  getConsultUrl,
  goConsultUrl,
  inquiryOnline,
  getVideoDoctorRight,
  getVideoDoctorUrl
}
